import AuthState from '@state/AuthState';
import { User } from 'oidc-client';
import React from 'react';

export interface IAuthContext extends AuthState {
  signInSilent: () => Promise<User>;
  signInRedirect: (path?: string) => void;
  signOut: () => void;
  signOutRedirectCallback: () => void;
  hasPermission: (permissionName: string) => boolean;
  accessToken?: string;
  isAuthenticated: boolean;
  isLoading: boolean;
  error?: Error;
  user?: User;
  isSignIn?: boolean;
}

export const AuthContext = React.createContext<IAuthContext | null>(null);

export const useAuth = (): IAuthContext => React.useContext(AuthContext) as IAuthContext;
